
let financeDocumentsFilters = $('.js-finance-documents-filter')

export function initFinanceDocumentsFilter(blocks){
  blocks.each(function(){
    let block = $(this)
    let clearFiltersB = block.find('.js-clear-filters')
    let yearsSelect = block.find('.js-year-select')
    let currentFilters = []

    yearsSelect.each(function (i, el) {
      let type = $(el).data('type')
      let typeDocumentsBlock = block.find('.js-filtered-documents-type[data-type="'+ type +'"]')
      let typeDocuments = typeDocumentsBlock.find('.js-filtered-documents')
      let documentsArr = []

      typeDocuments.find('.js-document').each(function(i, el){
        documentsArr.push($(el).clone())
      })

      currentFilters[i] = {
        type: type,
        year: '',
        documents: documentsArr,
        block: typeDocumentsBlock,
        documentsBlock: typeDocuments,
        customSelect: $(el).parent()
      }

    })


    yearsSelect.change(function(){
      let curType = $(this).data('type')
      let curYear = $(this).val()

      $.each(currentFilters, function (i, el) {
        if (el.type === curType){
          el.year = curYear
        }
      })

      filterDocuments()

      if (currentFilters[0].year || currentFilters[1].year){
        clearFiltersB.fadeIn()
      } else {
        clearFiltersB.fadeOut()
      }

      if (!currentFilters[0].year && !currentFilters[1].year){
        currentFilters[0].block.fadeIn()
        currentFilters[1].block.fadeIn()
      } else {
        $.each(currentFilters, function (i, el) {
          if (el.type === curType) {
            el.block.fadeIn()
          } else {
            el.block.hide()
            el.customSelect.addClass('nothing-selected')
            el.customSelect.find('.title').text('')
          }
        })
      }

    })

    clearFiltersB.click(function (){
      $.each(currentFilters, function(i, el){
        el.year = ''
      })
      yearsSelect.val('').change()

    })


    function filterDocuments(){

      currentFilters.forEach((type)=> {
        type.documentsBlock.html('')

        type.documents.forEach((doc)=> {
          if (parseInt(type.year) === parseInt(doc.data('year')) || type.year === ''){
            type.documentsBlock.append(doc)
          }
        })

      })

    }

  })


}

initFinanceDocumentsFilter(financeDocumentsFilters)
